import Slider from '$tablet-app/src/app/components/Slider';
import { useBrightness } from '../hooks/useBrightness';

export const BrightnessSlider = () => {
  const { data, setBrightness } = useBrightness();

  return (
    <Slider
      value={data.data || 0}
      onValueChange={setBrightness.mutateAsync}
      minimumValue={0}
      maximumValue={1}
      step={0.1}
    />
  );
};
